<div class="vechicle-specification-sec">
  <div class="">
    <div class="content-heading">
      <h2 class="page-sub-title cv-text-dark">Vehicle Specification</h2>
    </div>
    <div class="row">
              <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 ltr">
        <div class="img-box">
          <img [src]="getUrl(vehicleDetail?.lob,vehicleDetail?.ppl)" class="img-fluid" alt="vechicle-specification"
            loading="lazy">

        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 rtl mt-3 mt-md-0">
        <div class="flex-list">
          <div class="flex-item" *ngIf="vehicleDetail.payload != 'NA' && vehicleDetail.payload">
            <div class="flex-icon">
              <img [src]='environment1 + "assets/images/Line icon_Payload_capacity.png"' class="img-fluid" alt="Payload Capacity"
                loading="lazy">
            </div>
            <div class="flex-content">
              <h4>Payload Capacity</h4>
              <p>{{vehicleDetail?.payload?vehicleDetail?.payload:'-'}}</p>
            </div>
          </div>
          <div class="flex-item" *ngIf="vehicleDetail.max_power != 'NA' && vehicleDetail.max_power && (((vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric') && (vehicleDetail.fuel_tank_capacity != 'NA' && vehicleDetail.fuel_tank_capacity)) || ((vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric') && (vehicleDetail.battery_capacity != 'NA' && vehicleDetail.battery_capacity))) ">
            <div class="flex-icon">
              <img [src]='environment1 + "assets/images/Power.svg"' class="img-fluid" alt="Power" loading="lazy">
            </div>
            <div class="flex-content">
              <h4
                *ngIf="(vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric') && (vehicleDetail.fuel_tank_capacity != 'NA' && vehicleDetail.fuel_tank_capacity)">
                Max Power</h4>
              <h4
                *ngIf="(vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric') && (vehicleDetail.battery_capacity != 'NA' && vehicleDetail.battery_capacity)">
                Max Motor Power</h4>
              <p>{{vehicleDetail?.max_power?vehicleDetail?.max_power:'-'}}</p>
            </div>
          </div>
          <div class="flex-item" *ngIf="vehicleDetail.max_torque != 'NA' && vehicleDetail.max_torque ">
            <div class="flex-icon">
              <img [src]='environment1 + "assets/images/Torquee.svg"' class="img-fluid" alt="Torque" loading="lazy">
            </div>
            <div class="flex-content">
              <h4>Max Torque</h4>
              <p>{{vehicleDetail?.max_torque?vehicleDetail?.max_torque:'-'}}</p>
            </div>
          </div>
          <div class="flex-item" *ngIf="vehicleDetail?.no_wheels !='NA' && vehicleDetail?.no_wheels !=''">
            <div class="flex-icon">
              <img [src]='environment1 + "assets/images/Tyres.svg"' class="img-fluid" alt="Tyres" loading="lazy">
            </div>
            <div class="flex-content">
              <h4>No. of wheels</h4>
              <p>{{vehicleDetail?.no_wheels}}</p>
            </div>
          </div>
          <div class="flex-item" *ngIf="vehicleDetail.warranty != 'NA' && vehicleDetail.warranty !='' ">
            <div class="flex-icon">
              <img [src]='environment1 + "assets/images/Warranty.svg"' class="img-fluid" alt="Warranty" loading="lazy">
            </div>
            <div class="flex-content">
              <h4>Warranty</h4>
              <p>{{vehicleDetail?.warranty?vehicleDetail?.warranty:'-'}}</p>
            </div>
          </div>
          <div class="flex-item" *ngIf="((vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric')
          && (vehicleDetail.battery_capacity != 'NA' && vehicleDetail.battery_capacity)) ||
          ((vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric') &&
            (vehicleDetail.fuel_tank_capacity != 'NA' && vehicleDetail.fuel_tank_capacity !=''))
          ">
            <div class="flex-icon" *ngIf="((vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric')
            && (vehicleDetail.battery_capacity != 'NA' && vehicleDetail.battery_capacity)) ||
            ((vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric') &&
              (vehicleDetail.fuel_tank_capacity != 'NA' && vehicleDetail.fuel_tank_capacity !=''))
            ">
              <img [src]='environment1 + "assets/images/Fueltankcapacity.svg"' class="img-fluid" loading="lazy" alt="Fuel tank capacity">
            </div>
            <div class="flex-content"
              *ngIf="(vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric')
              && (vehicleDetail.battery_capacity != 'NA' && vehicleDetail.battery_capacity)">
              <h4>Battery Capacity (kWh)</h4>
              <p>
                {{ vehicleDetail.battery_capacity ? vehicleDetail.battery_capacity : "-" }}
              </p>
            </div>
            <div class="flex-content"
              *ngIf="(vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric') &&
              (vehicleDetail.fuel_tank_capacity != 'NA' && vehicleDetail.fuel_tank_capacity !='')">
              <h4>Fuel tank capacity</h4>
              <p>{{vehicleDetail?.fuel_tank_capacity?vehicleDetail?.fuel_tank_capacity:'-'}}</p>
            </div>
          </div>
        </div>
        <div class="view-specific">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#product-specification">View
            All Specification
            <img [src]="environment1 + 'images/new-images/rightArrowblue.svg'" alt="right Arrowblue" loading="lazy">
          </a>
        </div>
      </div>
      <!-- </ng-template> -->
    </div>
  </div>
</div>
<div class="modal fade" id="product-specification" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="product-specificationLabel" aria-hidden="true">
  <div class="modal-dialog modal-right">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="product-specificationLabel">Vehicle Specification</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">
        <div class="d-flex align-items-start specification">
          <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <button class="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home"
              type="button" role="tab" aria-controls="v-pills-home" aria-selected="true" *ngIf="vehicleDetail.product_description != 'NA' && vehicleDetail.product_description || vehicleDetail.vehicle_application != 'NA' && vehicleDetail.vehicle_application ||
                            vehicleDetail.product_category != 'NA' && vehicleDetail.product_category || vehicleDetail.product_type != 'NA' && vehicleDetail.product_type || vehicleDetail.price_range != 'NA' && vehicleDetail.price_range ||
                            vehicleDetail.max_torque != 'NA' && vehicleDetail.max_torque">Vehicle Information</button>
            <button class="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile"
              type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false"
              *ngIf="vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric' && (vehicleDetail.max_power != 'NA' && vehicleDetail.max_power) || (vehicleDetail?.fuel_type == '-' || vehicleDetail?.fuel_type == 'Electric') && (vehicleDetail.max_motor_power != 'NA' && vehicleDetail.max_motor_power) ||
                            vehicleDetail.max_torque != 'NA' && vehicleDetail.max_torque || vehicleDetail.emission_norms != 'NA' && vehicleDetail.emission_norms || vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric' && (vehicleDetail.engine_type != 'NA' && vehicleDetail.engine_type) || (vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric') ||
                            (vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric') && (vehicleDetail.motor != 'NA' && vehicleDetail.motor) || vehicleDetail.engine_cylinders != 'NA' && vehicleDetail.engine_cylinders || vehicleDetail.gradeability != 'NA' && vehicleDetail.gradeability || (vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric') ||
                            vehicleDetail.fuel_type != 'NA' && vehicleDetail.fuel_type || vehicleDetail.clutch_type != 'NA' && vehicleDetail.clutch_type || vehicleDetail.gearbox != 'NA' && vehicleDetail.gearbox">Performance</button>
            <button class="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages"
              type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false"
              *ngIf="vehicleDetail.gvw != 'NA' && vehicleDetail.gvw || vehicleDetail.wheelbase != 'NA' && vehicleDetail.wheelbase || vehicleDetail.width != 'NA' && vehicleDetail.width ||
                            vehicleDetail.height != 'NA' && vehicleDetail.height || vehicleDetail?.length != 'NA' && vehicleDetail?.length || vehicleDetail.cabin_type != 'NA' && vehicleDetail.cabin_type || vehicleDetail.load_body_length != 'NA' && vehicleDetail.load_body_length || vehicleDetail.load_body_type != 'NA' && vehicleDetail.load_body_type ||
                            vehicleDetail.load_body_dimensions != 'NA' && vehicleDetail.load_body_dimensions || vehicleDetail.seating_capacity_layout != 'NA' && vehicleDetail.seating_capacity_layout || vehicleDetail.passenger_door != 'NA' && vehicleDetail.passenger_door || vehicleDetail.side_windows != 'NA' && vehicleDetail.side_windows || vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack ||
                            vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack || vehicleDetail.no_wheels != 'NA' && vehicleDetail.no_wheels || vehicleDetail.front_tyre != 'NA' && vehicleDetail.front_tyre || vehicleDetail.rear_tyre != 'NA' && vehicleDetail.rear_tyre ||
                            vehicleDetail.front_suspension != 'NA' && vehicleDetail.front_suspension || vehicleDetail.rear_suspension != 'NA' && vehicleDetail.rear_suspension">Design & Build</button>
            <button class="nav-link" id="v-pills-settings-tab" data-bs-toggle="pill" data-bs-target="#v-pills-settings"
              type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false"
              *ngIf="vehicleDetail.air_conditioning != 'NA' && vehicleDetail.air_conditioning || vehicleDetail.telematics != 'NA' && vehicleDetail.telematics || vehicleDetail.seat_type != 'NA' && vehicleDetail.seat_type">Comfort</button>
            <button class="nav-link" id="v-pills-safety-tab" data-bs-toggle="pill"
              *ngIf="vehicleDetail.brake_type != 'NA' && vehicleDetail.brake_type || vehicleDetail.hill_hold != 'NA' && vehicleDetail.hill_hold"
              data-bs-target="#v-pills-safety" type="button" role="tab" aria-controls="v-pills-settings"
              aria-selected="false">Safety</button>
            <button class="nav-link" id="v-pills-warranty-tab" data-bs-toggle="pill"
              *ngIf="vehicleDetail.warranty != 'NA' && vehicleDetail.warranty" data-bs-target="#v-pills-warranty"
              type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false">Warranty</button>

          </div>
          <div class="tab-content" id="v-pills-tabContent">
            <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab"
              *ngIf="vehicleDetail.product_description != 'NA' && vehicleDetail.product_description || vehicleDetail.vehicle_application != 'NA' && vehicleDetail.vehicle_application ||
                            vehicleDetail.product_category != 'NA' && vehicleDetail.product_category || vehicleDetail.product_type != 'NA' && vehicleDetail.product_type || vehicleDetail.price_range != 'NA' && vehicleDetail.price_range ||
                            vehicleDetail.max_torque != 'NA' && vehicleDetail.max_torque">
              <div class="header">VEHICLE INFORMATION</div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.product_description != 'NA' && vehicleDetail.product_description ">
                <span>Vehicle Description</span>
                <p>{{vehicleDetail?.product_description?vehicleDetail?.product_description:'-'}}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.vehicle_application != 'NA' && vehicleDetail.vehicle_application ">
                <span>Vehicle Application</span>
                <p>{{vehicleDetail?.vehicle_application ? vehicleDetail?.vehicle_application : "-"}}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.product_category != 'NA' && vehicleDetail.product_category ">
                <span>Product Category</span>
                <p>{{ vehicleDetail?.product_category ? vehicleDetail?.product_category : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.product_type != 'NA' && vehicleDetail.product_type ">
                <span>Product Type</span>
                <p>{{ vehicleDetail?.product_type ? vehicleDetail?.product_type : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.price_range != 'NA' && vehicleDetail.price_range ">
                <span>Price</span>
                <p>{{ vehicleDetail?.price_range ? (vehicleDetail?.price_range
                  |currency:'INR':'symbol':'4.0-0') : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.steering_type != 'NA' && vehicleDetail.steering_type ">
                <span>Steering Type</span>
                <p>{{ vehicleDetail?.steering_type ? vehicleDetail?.steering_type : "-" }}</p>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab"
              *ngIf="vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric' && (vehicleDetail.max_power != 'NA' && vehicleDetail.max_power) || (vehicleDetail?.fuel_type == '-' || vehicleDetail?.fuel_type == 'Electric') && (vehicleDetail.max_motor_power != 'NA' && vehicleDetail.max_motor_power) ||
                            vehicleDetail.max_torque != 'NA' && vehicleDetail.max_torque || vehicleDetail.emission_norms != 'NA' && vehicleDetail.emission_norms || vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric' && (vehicleDetail.engine_type != 'NA' && vehicleDetail.engine_type) || (vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric') ||
                            (vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric') && (vehicleDetail.motor != 'NA' && vehicleDetail.motor) || vehicleDetail.engine_cylinders != 'NA' && vehicleDetail.engine_cylinders || vehicleDetail.gradeability != 'NA' && vehicleDetail.gradeability || (vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric') ||
                            vehicleDetail.fuel_type != 'NA' && vehicleDetail.fuel_type || vehicleDetail.clutch_type != 'NA' && vehicleDetail.clutch_type || vehicleDetail.gearbox != 'NA' && vehicleDetail.gearbox">
              <div class="header">PERFORMANCE</div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric' && vehicleDetail?.fuel_type != 'ELECTRIC'
 && (vehicleDetail.max_power != 'NA' && vehicleDetail.max_power)">
                <span>Max Power</span>
                <p>{{ vehicleDetail?.max_power ? vehicleDetail?.max_power : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="(vehicleDetail?.fuel_type == '-' || vehicleDetail?.fuel_type == 'Electric' || vehicleDetail?.fuel_type == 'ELECTRIC') && (vehicleDetail.max_motor_power != 'NA' && vehicleDetail.max_motor_power)">
                <span>Max Motor Power</span>
                <p>{{ vehicleDetail?.max_motor_power ? vehicleDetail?.max_motor_power : "-" }}</p>
              </div>




              <div class="title-subtitle" *ngIf="vehicleDetail.max_torque != 'NA' && vehicleDetail.max_torque ">
                <span>Max Torque</span>
                <p>{{ vehicleDetail?.max_torque ? vehicleDetail?.max_torque : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.emission_norms != 'NA' && vehicleDetail.emission_norms ">
                <span>Emission Norms</span>
                <p>{{ vehicleDetail?.emission_norms ? vehicleDetail?.emission_norms : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric' && (vehicleDetail.engine_type != 'NA' && vehicleDetail.engine_type)">
                <span>Engine Type</span>
                <p>{{ vehicleDetail?.engine_type ? vehicleDetail?.engine_type : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="(vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric') && (vehicleDetail.motor != 'NA' && vehicleDetail.motor)">
                <span>Motor Type</span>
                <p>{{ vehicleDetail?.motor ? vehicleDetail?.motor : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.engine_cylinders != 'NA' && vehicleDetail.engine_cylinders ">
                <span>Engine Cylinders</span>
                <p>{{ vehicleDetail?.engine_cylinders ? vehicleDetail?.engine_cylinders : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.gradeability != 'NA' && vehicleDetail.gradeability">
                <span>Gradeability (%)</span>
                <p>{{ vehicleDetail?.gradeability ? vehicleDetail?.gradeability : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="(vehicleDetail?.fuel_type != 'EV' && vehicleDetail?.fuel_type != 'Electric')">
                <span>Fuel Tank Capacity (Litres)</span>
                <p>{{ vehicleDetail?.fuel_tank_capacity ? vehicleDetail?.fuel_tank_capacity : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="(vehicleDetail?.fuel_type == 'EV' || vehicleDetail?.fuel_type == 'Electric') ">
                <span>Battery Capacity (kWh)</span>
                <p> {{ vehicleDetail.battery_capacity ? vehicleDetail.battery_capacity : "-" }}</p>
              </div>

              <div class="title-subtitle" *ngIf="vehicleDetail.fuel_type != 'NA' && vehicleDetail.fuel_type ">
                <span>Fuel Type</span>
                <p>{{ vehicleDetail?.fuel_type ? vehicleDetail?.fuel_type : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.clutch_type != 'NA' && vehicleDetail.clutch_type ">
                <span>Clutch Type</span>
                <p>{{ vehicleDetail?.clutch_type ? vehicleDetail?.clutch_type : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.gearbox != 'NA' && vehicleDetail.gearbox ">
                <span>Gearbox</span>
                <p>{{ vehicleDetail?.gearbox ? vehicleDetail?.gearbox : "-" }}</p>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab"
              *ngIf="vehicleDetail.gvw != 'NA' && vehicleDetail.gvw || vehicleDetail.wheelbase != 'NA' && vehicleDetail.wheelbase || vehicleDetail.width != 'NA' && vehicleDetail.width ||
                            vehicleDetail.height != 'NA' && vehicleDetail.height || vehicleDetail?.length != 'NA' && vehicleDetail?.length || vehicleDetail.cabin_type != 'NA' && vehicleDetail.cabin_type || vehicleDetail.load_body_length != 'NA' && vehicleDetail.load_body_length || vehicleDetail.load_body_type != 'NA' && vehicleDetail.load_body_type ||
                            vehicleDetail.load_body_dimensions != 'NA' && vehicleDetail.load_body_dimensions || vehicleDetail.seating_capacity_layout != 'NA' && vehicleDetail.seating_capacity_layout || vehicleDetail.passenger_door != 'NA' && vehicleDetail.passenger_door || vehicleDetail.side_windows != 'NA' && vehicleDetail.side_windows || vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack ||
                            vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack || vehicleDetail.no_wheels != 'NA' && vehicleDetail.no_wheels || vehicleDetail.front_tyre != 'NA' && vehicleDetail.front_tyre || vehicleDetail.rear_tyre != 'NA' && vehicleDetail.rear_tyre ||
                            vehicleDetail.front_suspension != 'NA' && vehicleDetail.front_suspension || vehicleDetail.rear_suspension != 'NA' && vehicleDetail.rear_suspension">
              <div class="header"
                *ngIf="vehicleDetail.gvw != 'NA' && vehicleDetail.gvw || vehicleDetail.wheelbase != 'NA' && vehicleDetail.wheelbase || vehicleDetail.width != 'NA' && vehicleDetail.width ||
                            vehicleDetail.height != 'NA' && vehicleDetail.height || vehicleDetail?.length != 'NA' && vehicleDetail?.length">
                DESIGN & BUILD</div>
              <div class="title-subtitle" *ngIf="vehicleDetail.gvw != 'NA' && vehicleDetail.gvw ">
                <span>GVW / GCW (Kgs)</span>
                <p>{{ vehicleDetail?.gvw ? vehicleDetail?.gvw : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.wheelbase != 'NA' && vehicleDetail.wheelbase ">
                <span>Wheelbase (mm)</span>
                <p>{{ vehicleDetail?.wheelbase ? vehicleDetail?.wheelbase : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.width != 'NA' && vehicleDetail.width ">
                <span>Overall Width (mm)</span>
                <p>{{ vehicleDetail?.width ? vehicleDetail?.width : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.height != 'NA' && vehicleDetail.height ">
                <span>Overall Height (mm)</span>
                <p>{{ vehicleDetail?.height ? vehicleDetail?.height : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail?.length != 'NA' && vehicleDetail?.length ">
                <span>Overall Length (mm)</span>
                <p>{{ vehicleDetail?.length ? vehicleDetail?.length : "-" }}</p>
              </div>
              <div class="header pt-4" *ngIf="vehicleDetail.cabin_type != 'NA' && vehicleDetail.cabin_type || vehicleDetail.load_body_length != 'NA' && vehicleDetail.load_body_length || vehicleDetail.load_body_type != 'NA' && vehicleDetail.load_body_type ||
                            vehicleDetail.load_body_dimensions != 'NA' && vehicleDetail.load_body_dimensions || vehicleDetail.seating_capacity_layout != 'NA' && vehicleDetail.seating_capacity_layout || vehicleDetail.passenger_door != 'NA' && vehicleDetail.passenger_door || vehicleDetail.side_windows != 'NA' && vehicleDetail.side_windows || vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack ||
                            vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack">Body & Cabin</div>
              <div class="title-subtitle" *ngIf="vehicleDetail.cabin_type != 'NA' && vehicleDetail.cabin_type ">
                <span>CABIN TYPE</span>
                <p>{{ vehicleDetail?.cabin_type ? vehicleDetail?.cabin_type : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.load_body_length != 'NA' && vehicleDetail.load_body_length ">
                <span>Load Body Length</span>
                <p>{{ vehicleDetail?.load_body_length ? vehicleDetail?.load_body_length : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.load_body_type != 'NA' && vehicleDetail.load_body_type ">
                <span>Load Body Type</span>
                <p>{{ vehicleDetail?.load_body_type ? vehicleDetail?.load_body_type : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.load_body_dimensions != 'NA' && vehicleDetail.load_body_dimensions">
                <span>Load Body Dimension</span>
                <p>{{vehicleDetail?.load_body_dimensions ? vehicleDetail?.load_body_dimensions : "-"}}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.seating_capacity_layout != 'NA' && vehicleDetail.seating_capacity_layout">
                <span>Seating Capacity & Layout</span>
                <p>{{vehicleDetail?.seating_capacity_layout? vehicleDetail?.seating_capacity_layout: "-"}}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.passenger_door != 'NA' && vehicleDetail.passenger_door">
                <span>Passenger Door</span>
                <p>{{ vehicleDetail?.passenger_door ? vehicleDetail?.passenger_door : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.side_windows != 'NA' && vehicleDetail.side_windows">
                <span>Side Windows</span>
                <p>{{ vehicleDetail?.side_windows ? vehicleDetail?.side_windows : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack">
                <span>Hat-rack</span>
                <p>{{ vehicleDetail?.hat_rack ? vehicleDetail?.hat_rack : "-" }}</p>
              </div>
              <div class="header pt-4" *ngIf="vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack">Axle Details
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.hat_rack != 'NA' && vehicleDetail.hat_rack">
                <span>Axle Configuration</span>
                <p>{{ vehicleDetail?.axle_configuration ? vehicleDetail?.axle_configuration : "-" }}</p>
              </div>
              <div class="header pt-4"
                *ngIf="vehicleDetail.no_wheels != 'NA' && vehicleDetail.no_wheels || vehicleDetail.front_tyre != 'NA' && vehicleDetail.front_tyre || vehicleDetail.rear_tyre != 'NA' && vehicleDetail.rear_tyre ">
                Wheels & Tyres</div>
              <div class="title-subtitle" *ngIf="vehicleDetail.no_wheels != 'NA' && vehicleDetail.no_wheels">
                <span>No. of Wheels</span>
                <p>{{ vehicleDetail?.no_wheels ? vehicleDetail?.no_wheels : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.front_tyre != 'NA' && vehicleDetail.front_tyre">
                <span>Front Tyre</span>
                <p>{{ vehicleDetail?.front_tyre ? vehicleDetail?.front_tyre : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.rear_tyre != 'NA' && vehicleDetail.rear_tyre">
                <span>Rear Tyre</span>
                <p>{{ vehicleDetail?.rear_tyre ? vehicleDetail?.rear_tyre : "-" }}</p>
              </div>
              <div class="header pt-4"
                *ngIf="vehicleDetail.front_suspension != 'NA' && vehicleDetail.front_suspension || vehicleDetail.rear_suspension != 'NA' && vehicleDetail.rear_suspension">
                Suspension</div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.rear_suspension != 'NA' && vehicleDetail.rear_suspension">
                <span>Rear Suspension</span>
                <p>{{ vehicleDetail?.rear_suspension ? vehicleDetail?.rear_suspension : "-" }}</p>
              </div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.front_suspension != 'NA' && vehicleDetail.front_suspension">
                <span>Front Suspension</span>
                <p>{{ vehicleDetail?.front_suspension ? vehicleDetail?.front_suspension : "-" }}</p>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab"
              *ngIf="vehicleDetail.air_conditioning != 'NA' && vehicleDetail.air_conditioning || vehicleDetail.telematics != 'NA' && vehicleDetail.telematics || vehicleDetail.seat_type != 'NA' && vehicleDetail.seat_type">
              <div class="header">COMFORT</div>
              <div class="title-subtitle"
                *ngIf="vehicleDetail.air_conditioning != 'NA' && vehicleDetail.air_conditioning">
                <span>A/C</span>
                <p>{{ vehicleDetail?.air_conditioning ? vehicleDetail?.air_conditioning : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.telematics != 'NA' && vehicleDetail.telematics">
                <span>Telematics</span>
                <p>{{ vehicleDetail?.telematics ? vehicleDetail?.telematics : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.seat_type != 'NA' && vehicleDetail.seat_type">
                <span>Seat Type</span>
                <p>{{ vehicleDetail?.seat_type ? vehicleDetail?.seat_type : "-" }}</p>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-safety" role="tabpanel" aria-labelledby="v-pills-safety-tab"
              *ngIf="vehicleDetail.brake_type != 'NA' && vehicleDetail.brake_type || vehicleDetail.hill_hold != 'NA' && vehicleDetail.hill_hold">
              <div class="header">SAFETY</div>
              <div class="header pt-4">Brakes System</div>
              <div class="title-subtitle" *ngIf="vehicleDetail.brake_type != 'NA' && vehicleDetail.brake_type">
                <span>Brake Type</span>
                <p>{{ vehicleDetail?.brake_type ? vehicleDetail?.brake_type : "-" }}</p>
              </div>
              <div class="title-subtitle" *ngIf="vehicleDetail.hill_hold != 'NA' && vehicleDetail.hill_hold">
                <span>Hill Hold</span>
                <p>{{ vehicleDetail?.hill_hold ? vehicleDetail?.hill_hold : "-" }}</p>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-warranty" role="tabpanel" aria-labelledby="v-pills-warranty-tab"
              *ngIf="vehicleDetail.warranty != 'NA' && vehicleDetail.warranty">
              <div class="header">WARRANTY</div>
              <div class="title-subtitle" *ngIf="vehicleDetail.warranty != 'NA' && vehicleDetail.warranty">
                <span>Warranty</span>
                <p>{{ vehicleDetail?.warranty ? vehicleDetail?.warranty : "-" }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
